// extracted by mini-css-extract-plugin
module.exports = {"header":"view_header__1mVFx","closeBtn":"view_closeBtn__3caXA","ownerCont":"view_ownerCont__1nPh2","title":"view_title__1jgcu"};